import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { delay } from 'rxjs/operators';
import { HttpLoadingService } from '../../../shell/http-loading.service';

@Component({
  selector: 'lfw-form-edit-toolbar',
  templateUrl: './form-edit-toolbar.component.html',
  styleUrl: './form-edit-toolbar.component.scss',
  imports: [MatToolbarModule, MatProgressBar, AsyncPipe]
})
export class FormEditToolbarComponent {
  protected readonly loading$ = inject(HttpLoadingService).loading$.pipe(delay(1));
}
